import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";
import { useMemo, useState } from "react";
import type { GetPlanActionItemDto } from "src/http";
import { StrategicContextPicker } from "..";

interface IProps {
  open: boolean;
  actionItemGuid?: string;
  context?: {
    team: {
      slug: string;
      name: string;
    };
    actionItemGuid: string;
  };
  onUpdateClicked?: (
    selectedContextActionItemGuid: string | null,
    currentContextActionItemGuid: string | null,
  ) => Promise<void>;
  onCancelled: () => void;
}

const EditContextModal = (props: IProps) => {
  const [selectedActionItem, setSelectedActionItem] = useState<GetPlanActionItemDto | null>(null);
  const [isSaving, setIsSaving] = useState<boolean>(false);

  const defaultContext = useMemo(() => {
    if (props.context) {
      return {
        teamSlug: props.context?.team!.slug,
        actionItemGuid: props.context?.actionItemGuid,
      };
    } else {
      return undefined;
    }
  }, [props.context]);

  function handleCancelClicked() {
    props.onCancelled();
  }

  return (
    <Dialog open={props.open} onClose={handleCancelClicked}>
      <DialogTitle>Connect to Context</DialogTitle>
      <DialogContent>
        <Stack spacing={{ xs: 0.5, sm: 1 }}>
          <Typography>Select an item that provides context.</Typography>
          <StrategicContextPicker
            actionItemGuid={props.actionItemGuid}
            shouldHideChildren
            defaultContext={defaultContext}
            onSelect={(value) => setSelectedActionItem(value)}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" disabled={isSaving} onClick={handleCancelClicked}>
          Cancel
        </Button>
        <Button
          variant="contained"
          disabled={isSaving}
          endIcon={isSaving ? <CircularProgress size={20} sx={{ color: "grey.400" }} /> : null}
          onClick={async () => {
            setIsSaving(true);
            await props.onUpdateClicked?.(
              selectedActionItem?.actionItemGuid ?? null,
              selectedActionItem?.contextActionItemGuid ?? null,
            );
            setIsSaving(false);
          }}
        >
          Update
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export { EditContextModal };
